<template>
    <div  v-if="loaded" class="grid grid-cols-1 md:grid-cols-5 mt-3">
        <div class="md:col-span-12 pr-5">
            <div class="flex justify-end">
                <LoaderButton title="Enregistrer" @ok="handleUpdateBien" :disabled="checkFieldValid" ref="btnValidate"></LoaderButton>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 mt-1">
                <div class="md:mr-4">
                    <AppInput 
                        v-model='bien.libelle' 
                        class="mt-3" 
                        title='Libelle' 
                        id='libelle' 
                        :validations="['required']"
                        @hasError="handleFormError"
                    />
                    <AppInput v-model='bien.adresse' class="mt-3" title='Adresse' id='adresse'/>
                    <div class="grid grid-cols-1 md:grid-cols-2">
                        <AppInput v-model='bien.ville' class="mt-3 md:pr-2" title='Ville' id='ville'/>
                        <AppInput v-model='bien.cp' class="mt-3" title='Code postal' id='cp'/>
                    </div>
                </div>
                <div>
                    <div class="grid grid-cols-1 md:grid-cols-3">
                        <AppInput v-model='bien.loyer' class="mt-3 md:pr-2" title='Loyer' id='loyer' icon="euro-sign"/>
                        <AppInput v-model='bien.charges' class="mt-3 md:pr-2" title='Charges' id='charges' icon="euro-sign"/>
                        <div class="w-full mt-3 mr-2">
                            <label class="form-label" for="paiementDay">
                                Jour de paiement
                            </label>
                            <div
                                class="relative"
                            >
                                <Multiselect
                                    v-model='bien.paiement_day'
                                    id='paiementDay'
                                    :options="paiementDayOptions"
                                    v-bind="$multiselectBind"
                                    placeholder=""
                                />
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2">
                        <AppInput
                            v-model='bien.surface_plintes_a_plintes'
                            class="mt-3 md:pr-2"
                            title='Surface plintes à plintes (m²)'
                            id='surfacePlintesAPlintes'
                            :validations="['number']"
                            @hasError="handleFormError"
                        />
                        <AppInput
                            v-model='bien.surface_carrez'
                            class="mt-3"
                            title='Surface carrez (m²)'
                            id='surfaceCarrez'
                            :validations="['number']"
                            @hasError="handleFormError"
                        />
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2">
                        <AppInput v-model='bien.electricity_meter' class="mt-3 md:pr-2" title='N° Compteur Éléctrique' id='electricityMeter'/>
                        <AppInput v-model='bien.water_meter' class="mt-3" title="N° Compteur d'eau" id='waterMeter'/>
                    </div>
                </div>
            </div>
            <hr class="mt-5 text-gray-200">
            <p
                class="mt-3 text-xs text-indigo-400 dark:text-indigo-500 italic"
                title="Prix net vendeur + frais d'agence + frais de notaire"
            >
                Total : {{ totalAcquisitionDisplay }}
            </p>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 mt-3">
                <AppInput
                    v-model='bien.prix_net_vendeur'
                    class="mt-3"
                    title='Prix net vendeur'
                    id='prixNetVendeur'
                    :validations="['number']"
                    @hasError="handleFormError"
                    icon="euro-sign"
                    format="number"
                />
                <AppInput
                    v-model='bien.frais_agence'
                    class="mt-3"
                    title="Frais d'agence"
                    id='fraisAgence'
                    :validations="['number']"
                    @hasError="handleFormError"
                    icon="euro-sign"
                    format="number"
                />
                <AppInput
                    v-model='bien.frais_notaire'
                    class="mt-3"
                    title='Frais de notaire'
                    id='fraisNotaire'
                    :validations="['number']"
                    @hasError="handleFormError"
                    icon="euro-sign"
                    format="number"
                />
            </div>
            <hr class="mt-5 text-gray-200">
            <p
                class="mt-3 text-xs text-indigo-400 dark:text-indigo-500 italic"
                title="Montant emprunté + Montant apport"
            >
                Total : {{ totalFinancementDisplay }}
            </p>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 mt-3">
                <AppInput
                    v-model='bien.montant_emprunte'
                    class="mt-3"
                    title='Montant emprunté'
                    id='montantEmprunte'
                    :validations="['number']"
                    @hasError="handleFormError"
                    icon="euro-sign"
                    format="number"
                />
                <AppInput
                    v-model='bien.montant_apport'
                    class="mt-3"
                    title='Montant apport'
                    id='montantApport'
                    :validations="['number']"
                    @hasError="handleFormError"
                    icon="euro-sign"
                    format="number"
                />
            </div>
            <hr class="mt-5 text-gray-200">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 mt-3">
                <AppInput
                    v-model='bien.montant_vente'
                    class="mt-3"
                    title='Montant de la vente'
                    id='montantVente'
                    :validations="['number']"
                    @hasError="handleFormError"
                    icon="euro-sign"
                    format="number"
                />
            </div>
        </div>
    </div>
    <SpinnerLoader v-else class="mt-5"></SpinnerLoader>
</template>

<script>
import { inject } from 'vue'
import AppInput from './../../components/form/AppInput';
import SpinnerLoader from './../../components/loader/SpinnerLoader';
import LoaderButton from './../../components/form/LoaderButton';
import { mapGetters } from "vuex";
import Multiselect from 'vue-multiselect'

export default {
    components: {
        LoaderButton,
        SpinnerLoader,
        AppInput,
        Multiselect
    },
    data() {
        return {
            bien: {},
            loaded: false,
            formInvalid: [],
        }
    },
    computed: {
        checkFieldValid() {
            return this.formInvalid.length !== 0;
        },

        totalAcquisitionDisplay() {
            const values = [this.bien.prix_net_vendeur, this.bien.frais_agence, this.bien.frais_notaire]
                .map(value => parseFloat(value))
                .filter(value => !Number.isNaN(value));

            if (values.length === 0) {
                return '—';
            }

            const total = values.reduce((sum, value) => sum + value, 0);

            return `${total.toLocaleString('fr-FR')} €`;
        },

        totalFinancementDisplay() {
            const values = [this.bien.montant_emprunte, this.bien.montant_apport]
                .map(value => parseFloat(value))
                .filter(value => !Number.isNaN(value));

            if (values.length === 0) {
                return '—';
            }

            const total = values.reduce((sum, value) => sum + value, 0);

            return `${total.toLocaleString('fr-FR')} €`;
        },

        ...mapGetters({
            paiementDayOptions: 'getDayOptions',
        }),
    },
    created() {
        this.loadBien()
    },
    methods: {
        async loadBien() {
            const api = inject('api');

            this.loaded = false

            try {
                this.bien = await api.bien.getBien(this.$route.params.bienUuid);
            } catch (err) {
                return;
            }
            this.loaded = true
        },
        handleFormError(event) {
            if (event.value && !this.formInvalid.includes(event.name)) {
                this.formInvalid.push(event.name);
            }

            if (!event.value && this.formInvalid.includes(event.name)) {
                this.formInvalid = this.formInvalid.filter(f => f !== event.name)
            }
        },
        async handleUpdateBien() {
            if (this.checkFieldValid) {
                return;
            }

            this.$refs.btnValidate.activateLoader();

            const data = {
                libelle: this.bien.libelle,
                adresse: this.bien.adresse,
                cp: this.bien.cp,
                ville: this.bien.ville,
                paiement_day: this.bien.paiement_day && this.bien.paiement_day.length !== 0 ? this.bien.paiement_day : null,
                water_meter: this.bien.water_meter,
                electricity_meter: this.bien.electricity_meter,
            };

            if (this.bien.loyer) {
                data.loyer = parseFloat(this.bien.loyer)
            }

            if (this.bien.charges) {
                data.charges = parseFloat(this.bien.charges)
            }

            if (this.bien.prix_net_vendeur) {
                data.prix_net_vendeur = parseFloat(this.bien.prix_net_vendeur)
            }

            if (this.bien.frais_agence) {
                data.frais_agence = parseFloat(this.bien.frais_agence)
            }

            if (this.bien.frais_notaire) {
                data.frais_notaire = parseFloat(this.bien.frais_notaire)
            }

            if (this.bien.montant_emprunte) {
                data.montant_emprunte = parseFloat(this.bien.montant_emprunte)
            }

            if (this.bien.montant_apport) {
                data.montant_apport = parseFloat(this.bien.montant_apport)
            }

            if (this.bien.montant_vente) {
                data.montant_vente = parseFloat(this.bien.montant_vente)
            }
            
            if (this.bien.surface_plintes_a_plintes) {
                data.surface_plintes_a_plintes = parseFloat(this.bien.surface_plintes_a_plintes)
            }

            if (this.bien.surface_carrez) {
                data.surface_carrez = parseFloat(this.bien.surface_carrez)
            }

            await this.$api.bien.updateBien(this.bien.uuid, data)
            .then(() => {
                this.$toast({title: 'Succès', description: "Le bien à bien été enregistré."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })
            
            this.$refs.btnValidate.deactivateLoader();
        }
    },
};
</script>